import { useState } from "react";
import DowloadDocument from "../action/DownloadDocument";
import { DocumentTextIcon } from "@heroicons/react/24/outline";

export default function UploadedFileMoc({ documento, action }: any) {

    const [isOnlyDownload, setView] = useState<boolean>(false);
    
    const handleUpdate = () => {
        setView(true);
        action(true);
    }

    return (
        isOnlyDownload  
        // ? <span className="text-blue-600 text-base flex justify-end col-span-2">
        //     <DowloadDocument documento={documento} label={"Visualizza documento"} />
        //   </span>
        ? <></>
        : < div className = "col-span-2 border text-base mb-4 rounded-lg flex flex-col gap-y-2 items-center justify-center py-2 px-2" >
            <span className="text-gray-400 block">
                {/* <DowloadDocument documento={documento} label={"Visualizza documento"} /> */}
                <DocumentTextIcon className="w-12 h-12" />
            </span>
            {/* <span className="block text-center">oppure</span> */}
            <span onClick={handleUpdate} className="rounded-lg text-base cursor-pointer text-blue-600">Carica nuovo documento</span>
        </div >
    )
}